module.exports = __webpack_public_path__ + "static/highlanders-logo-8f5f2aa284dfd29022539cca4d2596ec.png";